module.exports = __webpack_public_path__ + "img/cz.2339f3df.svg";